import { render, staticRenderFns } from "./ReservationTrashItem.vue?vue&type=template&id=606fe4a0&scoped=true&"
import script from "./ReservationTrashItem.vue?vue&type=script&lang=ts&"
export * from "./ReservationTrashItem.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationTrashItem.vue?vue&type=style&index=0&id=606fe4a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606fe4a0",
  null
  
)

export default component.exports